export default {
  api: '//api.readyprint.epson.com',
  paymetric: '//xiecomm.worldpay.com',
  analytics: {
    account: 'epson',
    profile: 'subscription',
    environment: 'prod',
  },
  isDebugInfo: false,
}
